import { createIcon } from '@chakra-ui/react';

export const ZendeskMenuIcon = createIcon({
  displayName: 'ZendeskMenuIcon',
  viewBox: '0 0 40 40',
  path: (
    <>
      <mask
        id='mask0_19114_16464'
        style={{ maskType: 'alpha' }}
        maskUnits='userSpaceOnUse'
        x='0'
        y='0'
        width='40'
        height='41'
      >
        <circle cx='20' cy='20.25' r='20' fill='#C4C4C4' />
      </mask>
      <g mask='url(#mask0_19114_16464)'>
        <rect
          x='-3.51562'
          y='-6.12305'
          width='47.033'
          height='52.7473'
          fill='url(#pattern0_zd)'
        />
      </g>
      <defs>
        <pattern
          id='pattern0_zd'
          patternContentUnits='objectBoundingBox'
          width='1'
          height='1'
        >
          <use
            xlinkHref='#image0_19114_16464'
            transform='scale(0.0046729 0.00416667)'
          />
        </pattern>
        <image
          id='image0_19114_16464'
          width='214'
          height='240'
          xlinkHref='data:image/png;base64,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'
        />
      </defs>
    </>
  ),
});
